import { useId } from "react";

import { EmptyState } from "../../../../core/EmptyState.js";
import { Text } from "../../../../core/Text.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import { BoxCards, BoxCardsSkeleton } from "../../../shared/BoxCards.js";
import { LoadError } from "../../../shared/LoadError.js";
import type { BoxGridContent } from "../../boxesContent.js";

/** The catalog's boxes, or its loading, failed or empty state in their place. */
export function BoxesGrid({ title, currency, state }: BoxGridContent) {
  const id = useId();
  return (
    <section
      aria-labelledby={id}
      aria-busy={state.status === "loading" || undefined}
      className="flex flex-col gap-4"
    >
      <Text as="h2" id={id} variant="display-xl4" tone="primary">
        {title}
      </Text>
      {state.status === "loading" && <BoxCardsSkeleton columns="grid" count={10} />}
      {state.status === "error" && <LoadError message={state.message} />}
      {state.status === "empty" && (
        <EmptyState
          title={state.message}
          action={state.action && <ActionButton action={state.action} variant="secondary" />}
        />
      )}
      {state.status === "ready" && (
        <BoxCards cards={state.cards} currency={currency} columns="grid" />
      )}
    </section>
  );
}
